import React, { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import { Link, useLocation } from "react-router-dom"

import hamburgerIcon from "../../assets/common/hamburger.svg"
import leftArrow from "../../assets/common/prvsArrow.svg"
import { GlobalContext } from "../../context/GlobalContext.jsx"
import { getActivityIdByPathname } from "../../utils/utils.js"
import { userRoles } from "../Utility/userRoles.js"

const PageTitle = ({ routes }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const activityId = getActivityIdByPathname(location?.pathname)
    const permissionDetails = userRoles().findUserRolesForPage(
        activityId[0]?.activity_id
    )
    const [pagetitle, setPageTitle] = useState("Default Title")
    const [backButtonUrl, setBackButtonUrl] = useState(null)
    const { hamburger, setHamburger } = useContext(GlobalContext)
    const showAddNewBtn = ["/service-network"]

    useEffect(() => {
        let currentRoute = {}
        routes.forEach((parentRoute) => {
            const routeName = parentRoute.children.find(
                (route) => (route.path == location.pathname)
            )
            if (routeName) {
                currentRoute = routeName
            }
        })
        const currentTitle = currentRoute && currentRoute.title
        const backButtonUrl = currentRoute && currentRoute?.backButtonUrl

        setPageTitle(currentTitle)
        setBackButtonUrl(backButtonUrl)
    }, [location])

    const { t } = useTranslation()

    const handleBackButtonClick = () => {
        navigate("/priceMatrix")
    }
    const handleHamburgerIcon = () => {
        setHamburger(!hamburger)

    }

    return (
        <>
            { pagetitle && (pagetitle !== "invoiceHistory") && (
                <>
                    <div className={` ${ (pagetitle === "foundationData" ||
                            pagetitle === "userManagement" || pagetitle === "productManagement") ? "flex items-left" : ""}`}>
                        { (pagetitle === "foundationData" ||
                            pagetitle === "userManagement" || pagetitle === "productManagement") &&
                                <div className="flex mb-4 pr-4">
                                    <button onClick={ handleHamburgerIcon } type="button">
                                        <img
                                            alt="Hamburger"
                                            src={ hamburgerIcon }
                                            className="relative  fill-current rounded-full border 
                                    border-primary-100 hover:border-0 hover:bg-primary-150 p-2"
                                            height={ "30px" }
                                            width={ "36px" }
                                            title="Hide Sidebar"
                                        />
                                    </button>
                                </div>
                        }

                        <h1
                            className={ `flex items-center text-xl text-primary-50 font-black mb-2 ${showAddNewBtn.includes(location.pathname) ? "justify-between" : ""
                            }` }
                        >

                            { backButtonUrl &&
                                <button type="button" onClick={ handleBackButtonClick }>
                                    <img
                                        alt={ t("common.filter") }
                                        src={ leftArrow }
                                        className="relative fill-current p-2"
                                        height={ "36px" }
                                        width={ "36px" }
                                    />
                                </button>
                            }
                            { t(`pageTitle.${pagetitle}`) }
                            { permissionDetails &&
                                permissionDetails._write &&
                                showAddNewBtn.includes(location.pathname) &&
                                (
                                    <Link
                                        to="/service-network/add-service-center-address"
                                        className="float-right rounded-full pt-2 bg-primary-100 text-white 
                        font-bold text-sm  hover:bg-primary-150 hover:text-primary-50 h-9 px-4"
                                    >
                                        { t("pageTitle.addNew") }
                                    </Link>
                                ) }
                        </h1>
                    </div>
                </>
            )
            }
        </>
    )
}

export default PageTitle
